import type { AuthErrorKeyMap } from '../../../types/auth';

export const generalAuthErrorConfig: AuthErrorKeyMap = {
    key: 'general',
    value: {
        401: {
            reauthentication_needed: 'errors.frontend.updatePassword.reauthenticationNeeded',
            reauthentication_not_valid: 'errors.frontend.updatePassword.reauthenticationNotValid',
            session_expired: 'errors.frontend.updatePassword.sessionExpired',
            session_not_found: 'errors.frontend.updatePassword.sessionNotFound',
            no_authorization: 'errors.frontend.updatePassword.noAuthorization',
        },
        403: {
            user_banned: 'errors.frontend.updatePassword.userBanned',
        },
        404: {
            user_not_found: 'errors.frontend.updatePassword.userNotFound',
        },
        500: {
            unexpected_failure: 'errors.frontend.updatePassword.unexpectedFailure',
        },
        default: 'errors.frontend.general',
    },
};
